module.exports = __webpack_public_path__ + "static/img/h5-5.68c8955.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-5.png
// module id = ZW5b
// module chunks = 1